// extracted by mini-css-extract-plugin
export var alignCenter = "_5f-d";
export var bannerShown = "_5f-6";
export var buttonContent = "_5f-0";
export var cardList = "_5f-1";
export var centerContent = "_5f-2";
export var chevron = "_5f-3";
export var closePanelButton = "_5f-k";
export var conversationContextContainer = "_5f-l";
export var conversationDetailContainer = "_5f-4";
export var detailWrapper = "_5f-7";
export var dropdownButton = "_5f-e";
export var dropdownTitle = "_5f-9";
export var fullHeight = "_5f-5";
export var hidden = "_5f-a";
export var icon = "_5f-b";
export var mergeSuggestionWrapper = "_5f-m";
export var panel = "_5f-i";
export var portalButtonsWrapper = "_5f-c";
export var right = "_5f-j";
export var tableSummaryContainer = "_5f-8";
export var tableSummaryHeader = "_5f-g";
export var threeDotsButton = "_5f-f";
export var wide = "_5f-h";